var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArchitects(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_497)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 33C1 15.3269 15.3269 1 33 1V1C50.6731 1 65 15.3269 65 33V33C65 50.6731 50.6731 65 33 65V65C15.3269 65 1 50.6731 1 33V33Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M45.0058 15.5665C53.6491 17.7303 60.4792 24.5653 62.4845 33.3618C63.9749 39.9035 62.6765 46.6495 52.6407 49.1025C30.9614 54.4006 7.54774 52.6514 4.74155 42.045C1.93537 31.4387 7.14247 13.239 19.5312 12.1167C26.5956 11.4736 37.1904 13.6091 45.0058 15.5665Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 45H11V52H13V45Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 43H8V53H11V43Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37 48H29V51H37V48Z",
    fill: "#878787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47 49H18.7135L12 28H40.2885L47 49Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 46H20.9847L16 30H37.0134L42 46Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37 38H32.3147L31 34H35.6874L37 38Z",
    stroke: "#E6E6E6",
    strokeWidth: 2.03,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1067 41.2043L39 44H23.1957L20 34H27.8083L28.7055 36.8055H27.1561L27.9624 39.3333H32.7194",
    stroke: "#878787",
    strokeWidth: 0.6,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 44L32 40",
    stroke: "#878787",
    strokeWidth: 0.6,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 36.8H24.8629L24 37.8",
    stroke: "#878787",
    strokeWidth: 0.6,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 37H23",
    stroke: "#878787",
    strokeWidth: 0.6,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 43H26",
    stroke: "#99ADBA",
    strokeWidth: 0.6,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 35H27",
    stroke: "#99ADBA",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 31H25",
    stroke: "#E6E6E6",
    strokeWidth: 2.03,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 31H27",
    stroke: "#E6E6E6",
    strokeWidth: 2.03,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 40L19.4023 48H27L17 40ZM18.6771 42.4321L24.3925 47.0021H20.0512L18.6771 42.4321Z",
    fill: "#FFD200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6276 49H18L19.3743 47H50L48.6276 49Z",
    fill: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2066 25C57.2066 25 63.1874 28.5005 61.7878 33.0212C60.3881 37.5419 56.1873 39 56.1873 39L55 36.4233L57.2066 25Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M57.2066 25C57.2066 25 63.1874 28.5005 61.7878 33.0212C60.3881 37.5419 56.1873 39 56.1873 39L55 36.4233L57.2066 25Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6209 22.9297L49.5996 25.3579L51.5996 25.9L51.0221 21.9L49.6209 22.9297Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7719 19.0629C49.5539 18.9931 49.3227 18.9812 49.0992 19.0283C48.8756 19.0754 48.6669 19.1801 48.4919 19.3329C48.3169 19.4856 48.1811 19.6816 48.0969 19.903C48.0127 20.1245 47.9827 20.3644 48.0096 20.601C48.1277 21.7243 48.501 23.2895 49.6774 22.9538C51.4775 22.4403 50.9177 19.9912 50.9177 19.9912C50.6316 19.5706 50.233 19.2477 49.7719 19.0629V19.0629Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M49.5137 32.3743C49.5137 32.3743 47.7552 35.0115 50.7453 36.4468C53.7353 37.882 52.6996 44 52.6996 44L56.8768 43.1501C56.8768 43.1501 56.1581 40.8421 57.8096 35.7739C59.4611 30.7058 49.8266 27 49.8266 27L49.5137 32.3743Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7777 28.4561C49.7023 26.4319 46.7684 26.5369 45.8945 28.6541C45.6158 29.3804 45.5031 30.1622 45.565 30.9397C45.7879 35.0554 46.875 40.3356 44.4527 40.702C42.0305 41.0684 36.9166 37.3608 36.9166 37.3608L36 38.5C36 38.5 43.0633 47.4954 48.3032 42.4568C52.5101 38.4144 52.8144 32.2964 50.7777 28.4561Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5153 38.3352L32.9627 37.7457L35.9228 34.7637C35.9925 34.6934 36.0863 34.6547 36.1836 34.6562C36.2808 34.6576 36.3735 34.6991 36.4413 34.7714L36.4841 34.817C36.5519 34.8893 36.5892 34.9866 36.5878 35.0874C36.5864 35.1882 36.5464 35.2843 36.4767 35.3545L33.5166 38.3366L33.5153 38.3352Z",
    fill: "#68E1FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 38.5866L32 39L32.4377 38L33 38.5866Z",
    fill: "#24285B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37 37.4187C37 37.4187 36.3841 35.9662 35.399 36.0006C34.4139 36.0351 35.2627 38.388 35.9998 38.5L37 37.4187Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6869 66H28.6L30.5131 49H31.6L29.6869 66Z",
    fill: "#878787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5131 65H37.6L35.6869 49H34.6L36.5131 65Z",
    fill: "#878787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 49H7V54H15V49Z",
    fill: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2868 51H9.71324C9.31933 51 9 51.2239 9 51.5C9 51.7761 9.31933 52 9.71324 52H12.2868C12.6807 52 13 51.7761 13 51.5C13 51.2239 12.6807 51 12.2868 51Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 18H14V24H24V18Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 23H23",
    stroke: "#C9C9C9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 21H16V23H17V21Z",
    stroke: "#C9C9C9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 23H18V19.5876L17 19V23Z",
    stroke: "#C9C9C9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 21H18V23H20V21Z",
    stroke: "#C9C9C9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 20H19V21H20V20Z",
    stroke: "#C9C9C9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 22H20V23H21V22Z",
    stroke: "#C9C9C9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 17H29V24H40V17Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 18V23H38V21.147H35.3128V18H30Z",
    stroke: "#C9C9C9",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 23V21.6478V21",
    stroke: "#C9C9C9",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 18V20",
    stroke: "#C9C9C9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37 20H38",
    stroke: "#C9C9C9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37 19H38",
    stroke: "#C9C9C9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 18H35V19H36V18Z",
    stroke: "#C9C9C9",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 22H31",
    stroke: "#C9C9C9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 23V22",
    stroke: "#C9C9C9",
    strokeWidth: 1.015,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9502 20.4882C48.0948 20.5316 48.2427 20.5662 48.3928 20.5917C48.6018 20.6328 48.8056 20.6927 49.0007 20.7705L49.1607 20.8316C49.2724 20.8748 49.3673 20.946 49.4337 21.0363C49.5 21.1266 49.5349 21.232 49.534 21.3396C49.5103 21.5486 49.5362 21.7596 49.6102 21.9593C49.6842 22.1589 49.8046 22.3427 49.9637 22.499C50.1228 22.6553 50.3171 22.7805 50.5342 22.8668C50.7513 22.9531 50.9864 22.9984 51.2246 23C51.2246 23 52.7444 20.9915 51.5285 19.444C51.1705 19.017 50.709 18.6657 50.1776 18.4159C49.6462 18.1661 49.0583 18.024 48.4568 18C48.1151 17.9998 47.7843 18.1056 47.5222 18.2989C47.26 18.4921 47.0833 18.7605 47.0229 19.0571C46.9625 19.3537 47.0223 19.6596 47.1918 19.9212C47.3614 20.1829 47.6298 20.3836 47.9502 20.4882Z",
    fill: "#003353"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0028 24.3239L51.7273 24C51.7273 24 57.4663 24.0091 58.4708 26.148C59.4753 28.2869 59.2635 36.253 55.9453 42.7862L49.1494 43C49.1494 43 49.5267 38.1988 48.2604 35.5845C46.994 32.9701 43.0557 27.4124 50.0028 24.3239Z",
    fill: "#00A0F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.405 42.5L58 62.9972H56.405L52.8422 47.2576L48.8272 63H47L49.1898 43L56.405 42.5Z",
    fill: "#003353"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 64C15.8792 64 2 50.1208 2 33H0C0 51.2254 14.7746 66 33 66V64ZM64 33C64 50.1208 50.1208 64 33 64V66C51.2254 66 66 51.2254 66 33H64ZM33 2C50.1208 2 64 15.8792 64 33H66C66 14.7746 51.2254 0 33 0V2ZM33 0C14.7746 0 0 14.7746 0 33H2C2 15.8792 15.8792 2 33 2V0Z",
    fill: "#E6EBEE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_497"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 33C1 15.3269 15.3269 1 33 1V1C50.6731 1 65 15.3269 65 33V33C65 50.6731 50.6731 65 33 65V65C15.3269 65 1 50.6731 1 33V33Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchitects);
export default __webpack_public_path__ + "static/media/Architects.bef7932ccd66a829f1dd8a16374fc5df.svg";
export { ForwardRef as ReactComponent };